import { useState, useEffect } from 'react';
//import axios from 'axios';
import api from '../services/api';

export default function useFindUser() {
    const [user, setUser] = useState(null);
    const [isLoading, setLoading] = useState(true);

    useEffect(() =>{
        async function findUser() {
        await api.get('/user')
        .then(res => {
            setUser(res.data.currentUser);
            setLoading(false);
        }).catch(err => {
            // console.log('useFindUser: ',{err});
            if (err.response.data){
              setUser(err.response.data.currentUser);
            }
            setLoading(false);
        });
        }

        findUser();
    }, []);

    return {
        user,
        setUser,
        isLoading
    }
}
